import { Injectable } from "@angular/core";
import { EventData } from "@dfds-platform/business-components";
import {
    OktaTrackingData,
    Events,
    EventSubscriber,
} from "./okta-tracking.interfaces";
import { DataLayerService } from "../data-layer.service";

@Injectable()
export class OktaTrackingSubscriberService {
    constructor(private dataLayerService: DataLayerService) {}

    private validateLocale(locale: string): string {
        const isEnLocale = locale.toLowerCase().substring(0, 2) === "en";
        if (isEnLocale && locale.toLowerCase() !== "en-gb") return "en";

        return locale;
    }

    private getEventsArray() {
        const eventsArray: Events = [
            {
                subscriberEvent: "@dfds-event/USER_LOGIN_SUCCESS",
                trackingEvent: "userLogin",
            },
            {
                subscriberEvent: "@dfds-event/USER_LOGIN_FAIL",
                trackingEvent: "userLogin",
            },
            {
                subscriberEvent: "@dfds-event/CHANGE_PASSWORD_SUCCESS",
                trackingEvent: "changePassword",
            },
            {
                subscriberEvent: "@dfds-event/CHANGE_PASSWORD_FAIL",
                trackingEvent: "changePassword",
            },
            {
                subscriberEvent: "@dfds-event/FORGOT_PASSWORD_SUCCESS",
                trackingEvent: "forgotPassword",
            },
            {
                subscriberEvent: "@dfds-event/FORGOT_PASSWORD_FAIL",
                trackingEvent: "forgotPassword",
            },
            {
                subscriberEvent: "@dfds-event/USER_REGISTER_SUCCESS",
                trackingEvent: "userRegister",
            },
            {
                subscriberEvent: "@dfds-event/USER_REGISTER_FAIL",
                trackingEvent: "userRegister",
            },
            {
                subscriberEvent: "@dfds-event/NEWSLETTER_SUBSCRIBE_SUCCESS",
                trackingEvent: "newsletterSignUp",
            },
            {
                subscriberEvent: "@dfds-event/NEWSLETTER_SUBSCRIBE_FAIL",
                trackingEvent: "newsletterSignUp",
            },
            {
                subscriberEvent: "@dfds-event/LOGIN_OPEN",
                trackingEvent: "overlayOpen",
            },
        ];

        return eventsArray;
    }

    public trackOkta(subscribe: EventSubscriber) {
        this.getEventsArray().map((e) => {
            subscribe(e.subscriberEvent, (payload: EventData) => {
                const { locale, ...rest } = payload;
                const trackingData: OktaTrackingData = {
                    event: e.trackingEvent,
                    locale: this.validateLocale(locale),
                    bookingEngine: "seabookFlow",
                    ...rest,
                };
                this.dataLayerService.push(trackingData);
            });
        });
    }
}
